import React, { useEffect, useState } from 'react';
import TitleLineH1 from './TitleLineH1';
import GalleryModule from './GalleryModule';
import getPostsBySlug from '../../../../api/graphql/queries/getPostBySlug';
import items from '../ItemsModules/items';


const ReusableComponent = ({
  content, languages, activeLanguage, components, id, handlerSetComponents, handleReadableNameReusable, toggleRefetch,
}) => {
  const setComponent = (comp, reusableComponentSlugname, languages, activeLanguage, components, id, handlerSetComponents, toggleRefetch) => {
    if (Object.keys(comp).length) {
      switch (comp.type) {
        case 'TitleLineH1':
          return <TitleLineH1 reusableComponent={comp} reusableComponentSlugname={reusableComponentSlugname} languages={languages} activeLanguage={activeLanguage} id={id} components={components} handlerSetComponents={handlerSetComponents} />;
        case 'Gallery':
          return <GalleryModule reusableComponent={comp} reusableComponentSlugname={reusableComponentSlugname} languages={languages} activeLanguage={activeLanguage} id={id} components={components} handlerSetComponents={handlerSetComponents} isCarousel={false} toggleRefetch={toggleRefetch} />;
        case 'CarouselWithDescription':
          return <GalleryModule reusableComponent={comp} reusableComponentSlugname={reusableComponentSlugname} languages={languages} activeLanguage={activeLanguage} id={id} components={components} handlerSetComponents={handlerSetComponents} isCarousel toggleRefetch={toggleRefetch} />;
  
        default:
          console.log('Unexpected reusable component, please review ReusableComponent.jsx switch');
      }
    }
  };

  let _isMounted = false;
  const [type, setType] = useState({});
  const [reusableComponentSlugname, setReusableComponentSlugname] = useState();
  useEffect(() => {
    _isMounted = true;
    getPostsBySlug(content)
      .then((res) => {
        if (_isMounted) {
          setReusableComponentSlugname(content);
          const { post } = res;
          const component = JSON.parse(post.components)[0];
          const { readableName } = items.filter(i => i.content === component.type)[0];
          // handleReadableNameReusable(content, readableName);
          setType(component);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {
      _isMounted = false;
    };
  }, []);

  return <>{setComponent(type, reusableComponentSlugname, languages, activeLanguage, components, id, handlerSetComponents, toggleRefetch)}</>;
};

export default React.memo(ReusableComponent);
